import { getCookie, setCookie } from '../../utils/cookie';

const scrollPopup = document.querySelector('.scroll-popup');

let time = 0;
let timeout = 0;
let stopped = false;

function frame() {
  time += 1 / 60;

  if (timeout > time && !stopped) {
    return requestAnimationFrame(frame);
  }

  scrollPopup.classList.add('scroll-popup--visible');
}

if (scrollPopup && getCookie(`wp-vb-scroll-popup-${scrollPopup.dataset.id}`) !== 'closed') {
  const closeButton = document.querySelector('.scroll-popup__close');

  closeButton.addEventListener('click', () => {
    setCookie(`wp-vb-scroll-popup-${scrollPopup.dataset.id}`, 'closed', scrollPopup.dataset.exp);
    scrollPopup.classList.remove('scroll-popup--visible');
  });

  time = +getCookie(`wp-vb-scroll-popup-${scrollPopup.dataset.id}`);
  timeout = +scrollPopup.dataset.timeout;

  requestAnimationFrame(frame);
}

window.addEventListener('beforeunload', () => {
  stopped = true;

  if (scrollPopup) {
    if (getCookie(`wp-vb-scroll-popup-${scrollPopup.dataset.id}`) !== 'closed') {
      setCookie(`wp-vb-scroll-popup-${scrollPopup.dataset.id}`, time, scrollPopup.dataset.exp);
    }
  }
});